import { __rest } from '../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import ReactDatePicker from 'react-datepicker';
import { CalendarContainer } from '../Calendar/Container.js';
import { DatePickerDayStyles } from '../Calendar/Day.js';
import { CalendarHeader } from '../Calendar/Header.js';
import { DatePickerWeekDayStyles } from '../Calendar/WeekDay.js';
import { useBaseDatePicker } from './useBaseDatePicker.js';

function BaseDatePicker(_a) {
    var { children, customInput, format, locale = "en-US", startOpen, yearsOffset, monthsShown = 2, onCalendarClose, onCalendarOpen, shouldCloseOnSelect, "data-testid": dataTestId } = _a, rest = __rest(_a, ["children", "customInput", "format", "locale", "startOpen", "yearsOffset", "monthsShown", "onCalendarClose", "onCalendarOpen", "shouldCloseOnSelect", "data-testid"]);
    const { handleCloseCalendar, handleOpenCalendar, inputComponent, isOpen, ref } = useBaseDatePicker({
        startOpen,
        customInput,
        onCalendarClose,
        onCalendarOpen,
    });
    const isSingleCalendar = monthsShown === 1;
    return (jsx(DatePickerStylesWrapper, { "$isSingleCalendar": isSingleCalendar, children: jsx(DatePickerWeekDayStyles, { "$isSingleCalendar": isSingleCalendar, children: jsx(DatePickerDayStyles, { children: jsx("div", { "data-testid": dataTestId, ref: ref, children: jsx(ReactDatePicker, Object.assign({}, rest, { autoFocus: startOpen, calendarContainer: CalendarContainer, calendarStartDay: 1, customInput: inputComponent, dateFormat: format, formatWeekDay: (day) => day.slice(0, 2), monthsShown: monthsShown, open: isOpen, renderDayContents: (dayOfMonth) => jsx("span", { children: dayOfMonth }), shouldCloseOnSelect: shouldCloseOnSelect, renderCustomHeader: (props) => (jsx(CalendarHeader, Object.assign({}, props, { locale: locale, monthsShown: monthsShown, yearsOffset: yearsOffset }))), onCalendarClose: handleCloseCalendar, onCalendarOpen: handleOpenCalendar, onInputClick: handleOpenCalendar, fixedHeight: true, children: children })) }) }) }) }));
}
const SINGLE_CALENDAR_WIDTH = 260;
const DatePickerStylesWrapper = styled("div")(({ theme, $isSingleCalendar }) => ({
    ".react-datepicker": {
        alignItems: "stretch",
        "&-popper": {
            zIndex: 1,
        },
        "&__header": Object.assign(Object.assign({}, ($isSingleCalendar && { width: "100%" })), { display: "flex", flexDirection: "column", gap: theme.spacing(2) }),
        "&__children-container": {
            display: "flex",
            order: 1,
        },
        "&__aria-live": visuallyHidden,
        "&__month-container": Object.assign(Object.assign({}, ($isSingleCalendar && { width: SINGLE_CALENDAR_WIDTH })), { display: "flex", flexDirection: "column", alignItems: "center", order: 2 }),
        "&__month": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            rowGap: theme.spacing(0.5),
        },
        "&__week": Object.assign({ display: "flex", alignItems: "flex-start" }, ($isSingleCalendar && { gap: 4 })),
    },
}));

export { BaseDatePicker };
//# sourceMappingURL=BaseDatePicker.js.map
